import Controller from '@ember/controller'
import { tracked } from '@glimmer/tracking'
import type { ActivityType } from 'teacher-ui-client/components/assignments-admin/assignment-form'

export default class AssignmentsProductCreateController extends Controller {
  queryParams = ['activityType', 'bookCode', 'writingCode', 'ewiCode']

  @tracked activityType?: ActivityType

  @tracked bookCode?: string = ''

  @tracked writingCode?: string = ''

  // todo: remove this once writingCode is fully rolled out
  @tracked ewiCode?: string = ''
}

declare module '@ember/controller' {
  interface Registry {
    'assignments/product/create': AssignmentsProductCreateController
  }
}
